import React from 'react'

const stats = [
  { value: "60+", label: "Projects Delivered" },
  { value: "89%", label: "Client Satisfaction" },
  { value: "20+", label: "International Clients" },
]

const tags = ["Brand Story → Impact", "Working globally", "Est. 2023"]

export function AboutSection() {
  return (
    <section
      className="bg-white py-16 sm:py-20 lg:py-28"
    >
      <style>{`
        .about-tag {
          display: inline-block;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          padding: 4px 12px;
          border: 1px solid #d4d4d4;
          border-radius: 999px;
          color: #666;
        }

        .about-stat-divider {
          width: 1px;
          background: #efefef;
          align-self: stretch;
        }

        .about-image-left {
          overflow: hidden;
          border-radius: 10px;
          background: #f0ede8;
          flex: 1;
        }

        .about-image-left img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transform: translateZ(0);
          will-change: transform;
          transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .about-image-left:hover img {
          transform: scale(1.08) translateZ(0);
        }

        .about-image-right {
          overflow: hidden;
          border-radius: 10px;
          background: #f0ede8;
          flex: 1;
        }

        .about-image-right img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .about-image-right:hover img {
          transform: scale(1.04);
        }

        .stat-value {
          font-family: 'Playfair Display', Georgia, serif;
          font-weight: 700;
          font-size: clamp(32px, 4vw, 52px);
          color: #111;
          line-height: 1;
          letter-spacing: -0.02em;
        }

        .stat-label {
          font-size: 12px;
          color: #999;
          margin-top: 6px;
          font-weight: 500;
          letter-spacing: 0.02em;
        }

        .about-divider {
          width: 100%;
          height: 1px;
          background: #efefef;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Left — images */}
          <div className="hidden lg:flex flex-row order-2 lg:order-1" style={{ height: "660px" }}>
            <div className="about-image-left">
              <img src="/Keston%20PSD%206.jpg" alt="KDPS portrait" />
            </div>
          </div>

          {/* Right — content */}
          <div className="order-1 lg:order-2 space-y-8">
            <p className="about-tag">About us</p>

            <h2 style={{
              fontWeight: 700,
              fontSize: "clamp(26px, 3.5vw, 44px)",
              lineHeight: 1.15,
              color: "#111",
              maxWidth: "520px",
            }}>
              We help businesses create{" "}
              <span style={{ fontFamily: "'Playfair Display', Georgia, serif", fontStyle: "italic", fontWeight: 400, color: "#b91c1c" }}>authentic</span>{" "}
              digital brands through storytelling and design.
            </h2>

            {/* Tags */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {tags.map((tag) => (
                <span key={tag} className="about-tag" style={{ color: "#444", borderColor: "#e0e0e0" }}>
                  {tag}
                </span>
              ))}
            </div>

            <div className="about-divider" />

            {/* Stats */}
            <div style={{ display: "flex", alignItems: "stretch", gap: "0" }}>
              {stats.map((stat, i) => (
                <React.Fragment key={stat.value}>
                  {i > 0 && <div className="about-stat-divider" />}
                  <div style={{ flex: 1, padding: "8px 24px 8px 0", paddingLeft: i === 0 ? 0 : "24px" }}>
                    <div className="stat-value">{stat.value}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                </React.Fragment>
              ))}
            </div>

            <div className="about-divider" />

            {/* CTA */}
            
              <a
              href="https://wa.me/18763932065"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "13px",
                fontWeight: 600,
                color: "#111",
                textDecoration: "none",
                borderBottom: "1px solid #111",
                paddingBottom: "2px",
                transition: "opacity 0.2s",
              }}
              onMouseEnter={e => e.currentTarget.style.opacity = "0.4"}
              onMouseLeave={e => e.currentTarget.style.opacity = "1"}
            >
              Get in touch
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M7 17L17 7M17 7H7M17 7v10" />
              </svg>
            </a>
          </div>

        </div>
      </div>
    </section>
  )
}